var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmexIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.791016,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "#1F72CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09517 8.79102L2.91406 16.0378H6.7223L7.19441 14.8823H8.27355L8.74566 16.0378H12.9375V15.1559L13.311 16.0378H15.4793L15.8528 15.1373V16.0378H24.5706L25.6307 14.9123L26.6232 16.0378L31.1009 16.0471L27.9097 12.4346L31.1009 8.79102H26.6927L25.6608 9.89564L24.6995 8.79102H15.2156L14.4013 10.6615L13.5678 8.79102H9.7675V9.64287L9.34474 8.79102H6.09517ZM6.83205 9.82006H8.68836L10.7984 14.7341V9.82006H12.8319L14.4617 13.3434L15.9637 9.82006H17.987V15.0201H16.7559L16.7458 10.9454L14.9509 15.0201H13.8495L12.0446 10.9454V15.0201H9.51179L9.03162 13.8543H6.43745L5.95827 15.0191H4.60123L6.83205 9.82006ZM24.1196 9.82006H19.1134V15.017H24.0421L25.6307 13.2947L27.1618 15.017H28.7624L26.436 12.4336L28.7624 9.82006H27.2313L25.6507 11.5226L24.1196 9.82006ZM7.73508 10.6999L6.8804 12.7766H8.58876L7.73508 10.6999ZM20.3497 11.846V10.8967V10.8958H23.4734L24.8364 12.4139L23.413 13.9403H20.3497V12.904H23.0808V11.846H20.3497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.791016,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexIcon);
export default __webpack_public_path__ + "static/media/amex-icon.48850b70c1c72c38209188b2981c12fe.svg";
export { ForwardRef as ReactComponent };